import React, { useState } from 'react';

const AuthContext = React.createContext({

    userType: '',
    isLoggedIn: true,
    login: (token) => { },
    logout: () => { },
});

export const AuthContextProvider = (props) => {
    const initialToken = sessionStorage.getItem('userType');
    const [userType, setUserType] = useState(initialToken)
    const userIsLoggedIn = !!userType;

    const loginHandler = (token) => {
        setUserType(token);
        sessionStorage.setItem('userType', token);
    };

    const logoutHandler = () => {
        setUserType(null);
        sessionStorage.removeItem('userType');
    }
    const contextValue = {
        userType: userType,
        isLoggedIn: userIsLoggedIn,
        login: loginHandler,
        logout: logoutHandler
    }
    return <AuthContext.Provider value={contextValue}> {props.children}</AuthContext.Provider>;
};

export default AuthContext;